import { type FunctionalComponent, h } from '@stencil/core';

export interface IConversationalSearchMessagesInitialQuestion {
  query: string;
}

export const ConversationalSearchMessagesInitialQuestion: FunctionalComponent<
  IConversationalSearchMessagesInitialQuestion
> = (props) => (
  <span class="conversational-search-messages-initial-question">
    {props.query}
  </span>
);
